import React from 'react'
import { Box, useTheme } from '@mui/material'
import { useIntl } from 'react-intl'
import type { AssessmentType } from '@app/src/types/resourceExplorer'
import { getLevelConfigByValue } from '@app/src/utils/assessmentLevels'

interface LevelSquareBadgeProps {
  value?: number
  levelsCount?: number
  percentage?: number
  assessmentType?: AssessmentType
}

const LevelSquareBadge: React.FC<LevelSquareBadgeProps> = ({ value, levelsCount }) => {
  const theme = useTheme()
  const { formatMessage } = useIntl()
  const levelConfig = getLevelConfigByValue(theme, value, levelsCount, formatMessage)

  return (
    <Box
      display="flex"
      width={48}
      height={48}
      padding="8px 0px"
      flexDirection="column"
      justifyContent="center"
      alignItems="center"
      gap="4px"
      bgcolor={levelConfig.bgColor}
      position="relative"
    >
      <Box
        component="span"
        sx={{
          ...theme.typography.subtitle1,
          color: theme.palette.text.primary,
          lineHeight: 1,
        }}
      >
        {value}
      </Box>
      <Box width={8} height={8} bgcolor={levelConfig.dotColor} borderRadius="50%" />
    </Box>
  )
}

export default LevelSquareBadge
